import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { HttpService, CoreService, } from '../../../services';
import { TemplateModel } from '../../../models';
import * as echarts from 'echarts';
import EChartOption = echarts.EChartOption;
import { Dictionary } from 'lodash';

@Component({
  templateUrl: './ActionCoGraphTemplate.component.html',
  styleUrls: ['./ActionCoGraphTemplate.component.css']
})

//!\\ ne pas oublier de declarer le composent dans le template.module.ts et index.ts //!\\
export class ActionCoGraphTemplateComponent implements OnInit  {

  // Info de base du template qui utilisé lors de la sélection du template dans la page d'adminBo
  __TemplateInfo(): any {
    return {
      // Nom d'affichage du Template
      name: `Action Co`,
      // Info supplémentaire du template
      toolTips: `Graph des Action Co`,
      // Liste des tables où le template sera utilisable
      // ex: ['tBOGROUPE'] le template sera utilisable uniquement sur les bo de la table tBoGroupe)
      // ex 2: ['ALL'] le tempalte sera utilisable sur toutes les table 
      table: ['tDOClient']
    };
  }

  // Donnée relative au BO
  tpl: TemplateModel;
  errorMsg: string;
  _data: Array<any> = new Array<any>();

  @ViewChild('graph', { static: false }) graph: ElementRef;
  myChart: any;

  constructor(
    protected indParam: CoreService,
    protected template: TemplateModel,
    protected http: HttpService,
    protected renderer: Renderer2) {
    this.tpl = template;
  }


  ngOnInit() {
    this.tpl.Mode = 'ACTIONCO';
    this.http.postHttp<TemplateModel>(`${this.indParam.AppParams.apiUrl}api/boTemplate/`, this.tpl).subscribe((data: TemplateModel) => {
      if (!data.HasError) {
        if (Object.keys(data.QueryReturn).length > 0) {
          this.buildGraph(data.QueryReturn);
        } else {
          this.errorMsg = "Pas de données à afficher";
        }
      }
    });
  }



  buildGraph(pData: Dictionary<any>): void {
    //if (this.ChartData.data.length > 0) {
    const style: CSSStyleDeclaration = getComputedStyle(document.body);
    const success: string = style.getPropertyValue('--c-success');
    const Csecondary: string = style.getPropertyValue('--c-secondary');
    const danger: string = style.getPropertyValue('--c-danger');
  
    if (pData['ActionCoPerdu'] != 0) {
      this._data.push({ value: pData['ActionCoPerdu'], name: 'Perdu', itemStyle: { color: danger }, label: { position: 'inside' } })
    }
    if (pData['ActionCoGagne'] != 0) {
      this._data.push({ value: pData['ActionCoGagne'], name: 'Gagné', itemStyle: { color: success }, label: { position: 'inside' } })
    }
    if (pData['ActionCoEnCours'] != 0) {
      this._data.push({ value: pData['ActionCoEnCours'], name: 'En Cours', itemStyle: { color: Csecondary }, label: { position: 'inside' } })
    }



    if (this._data.length == 0) {
      this.errorMsg = "Pas de données à afficher";
    }


    if (!this.errorMsg) {


      //  const zoomMaxValue: number = this.ChartData.data.length > 21 ? Math.ceil(2000 / this.ChartData.data.length) : 100;

      setTimeout(() => {
        this.myChart = echarts.init(this.graph.nativeElement);
        this.myChart.setOption({
          title: {
            text: 'Action Commerciale',            
            left: 'center'
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
          },
          label: { formatter: function (data: any) { return data.value; } },
          series: [
            {
              type: 'pie',
              radius: '50%',
              data: this._data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        });


        this.renderer.setStyle(this.graph.nativeElement, 'width', `100%`);
        this.renderer.setStyle(this.graph.nativeElement, 'height', `100%`);
        this.myChart.resize();
      }, 1);




    }
    //const interval = setInterval(() => {
    //  const width = $(this.IdChart.includes("#") ? `${this.IdChart}` : `#${this.IdChart}`).width();
    //  const height = $(this.IdChart.includes("#") ? `${this.IdChart}` : `#${this.IdChart}`).height();
    //  if (width > 0 && height > 0) {
    //    this.renderer.setStyle(this.graph.nativeElement, 'width', `${width}px`);
    //    this.renderer.setStyle(this.graph.nativeElement, 'height', `${height}px`);
    //    this.myChart.resize();
    //    clearInterval(interval);
    //  }
    //}, 100);
  }  
}
